import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import MplusUnActiveIcon from 'shared/icons/mplus/mplus_unactive.webp'
import { priceShow } from 'shared/lib/priceShow'

import s from './styles.module.scss'

interface Props {
  price: string
}

export const DisabledMplusCard = ({ price }: Props) => {
  const { t } = useTranslation()
  return (
    <div className={s.disabledMplusCard}>
      <div className={s.icon}>
        <img src={MplusUnActiveIcon} />
      </div>

      <p className={clsx(s.description, 'regular-10')}>
        {t('mplus.disabled_mplus')}
      </p>
      <p className={clsx(s.price, 'semi-bold-14')}>
        {t('mplus.from_thousand', { price: priceShow(price) })}
      </p>
    </div>
  )
}
